import React from 'react';
import get from 'lodash/get';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import compose from 'recompose/compose';
import {FormattedMessage} from 'react-intl';
import {Modal, Table} from 'semantic-ui-react';
import defaultProps from 'recompose/defaultProps';
import setDisplayName from 'recompose/setDisplayName';
import {bool, func, string, arrayOf, shape} from 'prop-types';
import {createResourceSelector, createNestedResourceSelector} from 'resources/selectors';
import PrizeChallengesModal from './PrizeChallengesModal';
import {closePrizeChallengesModal} from './actions';
import {EmptyFunc} from 'utils/DBUtils';

const mapStateToProps = state => {
  const {isOpen, prizeId} = state.prizeChallengesModal;
  const getPrize = createResourceSelector(prizeId);

  // for the PrizeEntry dashboards, the Prize is nested on the PrizeEntry resource, so we
  // can use a selector to pluck it from there instead of fetching it anew from the server.
  const getNestedPrize = createNestedResourceSelector('prize', prizeId);

  const prize = getPrize(state.resources) || getNestedPrize(state.resources);

  return {
    isOpen,
    prize
  };
};

const mapDispatchToProps = {
  handleClose: closePrizeChallengesModal
};

export default compose(
  setDisplayName('PrizeChallengesModalContainer'),
  defaultProps({
    prize: {
      title: '',
      challengeIds: [],
      challengePermalinks: []
    },
    isOpen: false,
    handleClose: EmptyFunc
  }),
  connect(mapStateToProps, mapDispatchToProps)
)(props => (
  <Modal
    size='small'
    dimmer={true}
    closeIcon={true}
    open={props.isOpen}
    closeOnDimmerClick={true}
    onClose={props.handleClose}
    className='primary-modal prize-challenges-modal'>
    <Modal.Header>{props.prize.title}</Modal.Header>
    <Modal.Content scrolling={true}>
      <Table striped>
        <Table.Body>
          {props.prize.challengeIds.map((challengeId, index) => {
            const content = get(props.prize, `challengePermalinks[${index}]`, challengeId);
            return (
              <Table.Row key={challengeId}>
                <Table.Cell>
                  <Link onClick={props.handleClose} to={`/break/${challengeId}/edit`}>
                    {content}
                  </Link>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </Modal.Content>
  </Modal>
));



// WEBPACK FOOTER //
// ./public/components/PrizeChallengesModal/PrizeChallengesModal.jsx